import { render, staticRenderFns } from "./suporte-contratos-details.vue?vue&type=template&id=559344ad&scoped=true"
import script from "./suporte-contratos-details.vue?vue&type=script&lang=ts"
export * from "./suporte-contratos-details.vue?vue&type=script&lang=ts"
import style0 from "./suporte-contratos-details.vue?vue&type=style&index=0&id=559344ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559344ad",
  null
  
)

export default component.exports